import * as types from '../actionTypes';

export const toggleUserProfileModal = () => ({
    type: types.TOGGLE_USER_PROFILE_MODAL
});

export const toggleLoggoutConfirmModal = () => ({
    type: types.TOGGLE_LOGGOUT_CONFIRM_MODAL
});
